/**
 * Lo stock veicoli cambia di continuo — opzionamenti, vendite, import — e una
 * lista mostrata da cache e' una lista sbagliata.
 */
export const FRESH_VEHICLES_QUERY = {
	staleTime: 0,
	gcTime: 0,
	refetchOnMount: 'always',
	refetchOnWindowFocus: false,
	retry: false,
} as const;
